import { useState } from "react";
import { useAuth } from "../context/AuthContext.js";
import Navbar from "./Navbar.js";
import { AuthModal } from "./AuthModal.js";
import { Outlet } from "react-router-dom";

export default function Layout() {
  const { user, signOut, loading } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [initialAuthTab, setInitialAuthTab] = useState<"signin" | "signup">(
    "signin"
  );

  const handleLogout = async () => {
    await signOut();
  };

  const handleAuthAction = (tab: "signin" | "signup" = "signin") => {
    setInitialAuthTab(tab);
    setShowAuthModal(true);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading authentication...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F9F9F9] via-[#F7F7F7] to-[#B7B7B7]">
      <Navbar
        user={user}
        onLogout={handleLogout}
        onLogin={handleAuthAction}
      />
      <main>
        <Outlet />
      </main>
      <footer className="py-12 px-4 bg-gray-100 text-slate-700">
        <div className="container mx-auto text-center">
          <p className="text-sm text-slate-900">
            © 2025 PublicTrades, LLC. All rights reserved.
          </p>
        </div>
      </footer>
      {showAuthModal && (
        <AuthModal
          onClose={() => setShowAuthModal(false)}
          initialTab={initialAuthTab}
        />
      )}
    </div>
  );
}
